import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../common/createSxStyles";

export const useDataCategoriesStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
        },
        bold: {
            fontWeight: theme.typography.fontWeightBold,
        },
        iconContainer: {
            display: "flex",
        },
        checkIcon: {
            height: "20px !important",
        },
        switchBoxContainer: {
            marginBottom: theme.spacing(2.5),
            width: 180,
        },
    });
};
